export default __webpack_public_path__ + "static/linked-list-insertion-176f9ef46bc055ccdf3d42e8d0f9e476.png";